// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container--b3n6F"};